// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/pregnancy-and-flying.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/pregnancy-and-flying/cosmic-radiation-limits.js';
import g1 from '../lessons/aeronautics/pregnancy-and-flying/pregnancy-and-flying.js';

mount([g0, g1]);
